<template>
  <div>
    <div id="home" class="mhc_section mhc_fullwidth_section  mhc_section_0 mh_section_regular" data-bg-color="#ffffff">
      <div id="banner"
        class="mhc_module mhc_slider mhc_slider_no_arrows mh_slider_auto mh_slider_speed_6000 mh_slide_animation  mhc_fullwidth_slider_0">
        <div class="">
          <!-- <div v-if="getSlide"
            class=" mhc_slide_with_image has-white-color mhc_bg_layout_light mhc_media_alignment_center mhc_slide_0 mhc-active-slide mb-4"
            :style='{ "background-color": setting.find(item => item.key == "color1").value }'>
            <div class="mhc_container clearfix">
              <div class="mhc_slide_image"><img :src="resolveImage(getSlide.img)" alt="بنر موثوق" />
              </div>
              <div class="mhc_slide_description">
                <h2 class="mhc_slide_title has-white-color">{{ resolveByLocal(getSlide, 'title') }}</h2>
                <div class="mhc_slide_content has-white-color" v-html="resolveByLocal(getSlide, 'text')">
                </div>
                <router-link class="mhc_promo_button mhc_single_button mhc_solidify header-font-family"
                  :to="{ name: 'services' }">{{ $t('request_service') }}
                </router-link>
              </div>
            </div>
          </div>

          <div v-if="getSlide3"
            class=" mhc_slide_with_image has-white-color mhc_bg_layout_light mhc_media_alignment_center mhc_slide_0 mhc-active-slide mb-4"
            :style='{ "background-color": setting.find(item => item.key == "color3").value }'>
            <div class="mhc_container clearfix">
              <div class="mhc_slide_image"><img :src="resolveImage(getSlide2.img)" alt="بنر موثوق" />
              </div>
              <div class="mhc_slide_description">
                <h2 class="mhc_slide_title has-white-color">{{ resolveByLocal(getSlide3, 'title') }}</h2>
                <div class="mhc_slide_content has-white-color" v-html="resolveByLocal(getSlide3, 'text')">
                </div>
                <router-link class="mhc_promo_button mhc_single_button mhc_solidify header-font-family"
                  :to="{ name: 'services' }">{{ $t('request_service') }}
                </router-link>
              </div>
            </div>
          </div> -->

        </div>
        <div class="">
          <div v-if="this.content.find(item => item?.name === 'slider')">
            <Carousel>

              <Slide v-for="(item, index) in getContentWithoutVideo" :key="index" :transition="1000">
                <div class="slide-container " :style='{
                  "background-color": item?.backgroundColor ? item?.backgroundColor : "#6B1D45",
                  "width": "100vw"
                }'>
                  <div class="container">
                    <div class="row justify-content-between align-items-center">
                      <div class="col-md-6 align-self-center ">
                        <div class="mhc_slide_description px-3">
                          <h2 class="mhc_slide_title pt-0 " :style='{
                            "color": item?.titleColor ? item?.titleColor : "#ffffff",
                            "font-weight": "bold"
                          }'>{{ resolveByLocal(item, 'title') }}
                          </h2>

                          <div v-if="this.resolveByLocal(item, 'text').length > 201" class="mhc_slide_content " :style='{
                            "color": item?.contentColor ? item?.contentColor : "#ffffff",
                          }' v-html="resolveByLocal(item, 'text').slice(0, 150) + '.......'">
                          </div>
                          <div v-else class="mhc_slide_content " :style='{
                            "color": item?.contentColor ? item?.contentColor : "#ffffff",
                          }' v-html="resolveByLocal(item, 'text')">
                          </div>
                          <router-link class="mhc_promo_button mhc_single_button mhc_solidify header-font-family" :style='{
                            "color": item?.buttonColor ? item?.buttonColor : "#ffffff",
                            "background-color": item?.buttonBackgroundColor ? item?.buttonBackgroundColor : "#ffffff00",
                            "border-color": item?.buttonBorderColor ? item?.buttonBorderColor : "#ffffff",

                          }' :to="{ name: 'services' }">{{ $t('request_service') }}
                          </router-link>
                          {{ }}
                        </div>
                      </div>
                      <div v-if="item?.img" class="col-md-6 align-self-center order-md-last order-first">
                        <div class="d-flex justify-content-md-start justify-content-center">
                          <img :src="resolveImage(item?.img)" alt="بنر موثوق" />
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </Slide>

              <template #addons>
                <Navigation />
                <Pagination />
              </template>

            </Carousel>
          </div>
        </div>
        <div class="container">
          <div class="row align-items-center" v-if="getSlideVideo">
            <div class="col-md-6 align-self-center">
              <div class="mhc_slide_description px-3">
                <h2 class="mhc_slide_title pt-0 " :style='{
                  "color": getSlideVideo?.titleColor ? getSlideVideo?.titleColor : "#422a47",
                  "font-weight": "bold",
                  "font-size": "24px",

                }'>{{ resolveByLocal(getSlideVideo, 'title') }}
                </h2>
                <div v-if="this.resolveByLocal(getSlideVideo, 'text').length > 301" class="mhc_slide_content " :style='{
                  "color": getSlideVideo?.contentColor ? getSlideVideo?.contentColor : "#422a47",
                }' v-html="resolveByLocal(getSlideVideo, 'text').slice(0, 300) + ' ....... '">
                </div>
                <div v-else class="mhc_slide_content " :style='{
                  "color": getSlideVideo?.contentColor ? getSlideVideo?.contentColor : "#422a47",
                }' v-html="resolveByLocal(getSlideVideo, 'text')">
                </div>
                {{ }}
              </div>
            </div>
            <div class="col-md-6 align-self-center">
              <iframe v-if="getSlideVideo?.videoEmbedYoutube" :src="getSlideVideo?.videoEmbedYoutube" frameBorder="0"
                allowfullscreen className="iframe-video " title="Mawthuq"></iframe>
              <iframe v-else src="https://www.youtube.com/embed/1iWTl8DM7Rg" frameBorder="0" allowfullscreen
                className="iframe-video " title="Mawthuq"></iframe>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="mhc_section  mhc_section_3 mh_section_regular" data-bg-color="#6B1D45">
      <div class=" mhc_row mhc_row_2">
        <div class="mhc_column mhc_column_4_4 mhc_column_4">
          <div class="text-center">
            <h1 class="has-white-color" :style='{
              "font-weight": "bold"
            }'>{{ $t('main_check_items') }}</h1>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- <div class="row">
          <div class="col-md-6 col-sm-12 col-lg-3 " v-for="(item, index) in getMainFeatures" :key="index">
            <div class="" v-if="getMainFeature(index).img">
              <div
                class=" mhc_animation_scaleup mhc_fx_none mhc_image_2 mh_force_center_on_mobile mhc_image_sticky d-flex justify-content-center ">
                <img :src="resolveImage(item?.img)" />
              </div>
              <div class="mhc_text mhc_module mhc_pct mhc_bg_layout_light mhc_text_align_center has-white-color">
                <h4 class='has-white-color'>{{ resolveByLocal(getMainFeature(index), 'title') }}</h4>
                <p v-html="resolveByLocal(getMainFeature(index), 'text')"></p>
              </div>
            </div>
          </div>
        </div> -->



        <div class="row">
          <div class="col-md-6 col-lg-3 " v-for="(item, index) in getMainFeatures" :key="index">
            <div class="d-flex justify-content-center mh_force_center_on_mobile mhc_image_sticky ">
              <img :src="resolveImage(item?.img)" alt="Main Features" class="mhc_image_2 " />
            </div>
            <div class="mhc_text mhc_module mhc_pct mhc_bg_layout_light mhc_text_align_center has-white-color">
              <h4 :style='{
                "color": item?.titleColor ? item?.titleColor : "#ffffff",
                "font-weight": "bold"
              }'>{{ resolveByLocal(getMainFeature(index), 'title') }}</h4>
              <p v-html="resolveByLocal(getMainFeature(index), 'text')" :style='{
                "color": item?.contentColor ? item?.contentColor : "#ffffff",
              }'></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="">

        <div v-if="this.content.find(item => item?.name === 'homeReview')">
          <h1 class="text-center" :style='{
            "font-weight": "bold",
            "font-size": "24px",
          }'>{{ $t('homeReviewsTitle') }}</h1>

          <Carousel :autoplay="5000">

            <Slide v-for="(item, index) in getReviewsHome" :key="index" :transition="2000">
              <div class="slide-container " :style='{
                "background-color": "#ffffff",
                // "width": "100vw"
              }'>
                <div class="container">
                  <div class="row justify-content-between align-items-center">
                    <div class="col-12 align-self-center">
                      <div class=" d-flex justify-content-center">
                        <div>
                          <div class="d-flex justify-content-center mb-3">
                            <img
                              :src="item?.gender === 'female' ? 'assets/img/femaleUser.png' : 'assets/img/maleUser.png'"
                              :style='{
                                "max-width": "75px",
                              }' />
                          </div>
                          <div class="d-flex justify-content-center mb-3">
                            <img class="d-flex justify-content-center"
                              :src="item?.img ? resolveImage(item?.img) : 'assets/img/5Stars.svg'" :style='{
                              }' />
                          </div>

                          <div class="mhc_slide_content  " :style='{
                            "color": item?.contentColor ? item?.contentColor : "#422a47",
                          }' v-html="resolveByLocal(item, 'text')">
                          </div>
                          <h2 class="mhc_slide_title pt-0  text-center" :style='{
                            "color": item?.titleColor ? item?.titleColor : "#422a47",
                          }'>{{ resolveByLocal(item, 'title') }}
                          </h2>
                          <h5 v-if="item?.fromCountry" class="mhc_slide_title pt-0  text-center" :style='{
                            "color": item?.titleColor ? item?.titleColor : "#422a47",
                          }'>{{ item?.fromCountry }}
                          </h5>
                          <h5 v-else class="mhc_slide_title pt-0  text-center" :style='{
                            "color": item?.titleColor ? item?.titleColor : "#422a47",
                          }'>{{$t("qatar")}}
                          </h5>
                        </div>
                        <!-- <div class="mhc_slide_description px-3">
                          <h2 class="mhc_slide_title pt-0 " :style='{
                            "color": item?.titleColor ? item?.titleColor : "#ffffff",
                          }'>{{ resolveByLocal(item, 'title') }}
                          </h2>

                          <div v-if="this.resolveByLocal(item, 'text').length > 201" class="mhc_slide_content " :style='{
                            "color": item?.contentColor ? item?.contentColor : "#ffffff",
                          }' v-html="resolveByLocal(item, 'text').slice(0, 200) + '.......'">
                          </div>
                          <div v-else class="mhc_slide_content " :style='{
                            "color": item?.contentColor ? item?.contentColor : "#ffffff",
                          }' v-html="resolveByLocal(item, 'text')">
                          </div>
                          <router-link class="mhc_promo_button mhc_single_button mhc_solidify header-font-family" :style='{
                            "color": item?.buttonColor ? item?.buttonColor : "#ffffff",
                            "background-color": item?.buttonBackgroundColor ? item?.buttonBackgroundColor : "#ffffff00",
                            "border-color": item?.buttonBorderColor ? item?.buttonBorderColor : "#ffffff",

                          }' :to="{ name: 'services' }">{{ $t('request_service') }}
                          </router-link>
                          {{ }}
                        </div> -->
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </Slide>

            <template #addons>
              <Navigation />
              <Pagination />
            </template>

          </Carousel>
        </div>
      </div>
    </div>
    <!--    <div id="coverage" class="mhc_section  mhc_section_4 mh_section_regular" data-bg-color="#585e71">-->
    <!--      <div class=" mhc_row mhc_row_5">-->
    <!--        <div class="mhc_text mhc_module mhc_pct mhc_bg_layout_light mhc_text_align_center has-white-color">-->
    <!--          <h2><span style="color: #ffffff;">المدن المغطاة بالخدمة</span></h2>-->
    <!--        </div>-->
    <!--        <GMapMap :center="center" :zoom="13" map-type-id="terrain" style="width: 100%; height: 20rem">-->
    <!--          <GMapMarker :position="center" :clickable="true" :draggable="true">-->
    <!--          </GMapMarker>-->
    <!--        </GMapMap>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- <div class="mhc_section  mhc_section_5 mh_section_regular" data-bg-color="#ffffff">
      <div class=" mhc_row mhc_row_6">
        <div class="mhc_column mhc_column_4_4 mhc_column_14">
          <div class="mhc_code mhc_module  mhc_code_1">
            <div class="elfsight-widget-testimonials-slider elfsight-widget"
              data-elfsight-testimonials-slider-options="%7B%22template%22%3A%22singleSpotlight%22%2C%22layout%22%3A%22slider%22%2C%22sliderArrows%22%3Atrue%2C%22sliderDrag%22%3Afalse%2C%22sliderSpeed%22%3A0.6%2C%22sliderAutoplay%22%3A5%2C%22sliderPaginationType%22%3A%22none%22%2C%22widgetTitle%22%3A%22%5Cu0622%5Cu0631%5Cu0627%5Cu0621%20%5Cu0639%5Cu0645%5Cu0644%5Cu0627%5Cu0626%5Cu0646%5Cu0627%22%2C%22lang%22%3A%22ar%22%2C%22items%22%3A%5B%7B%22text%22%3A%22%5C%22%5Cu0623%5Cu0646%5Cu0627%20%5Cu0634%5Cu062e%5Cu0635%20%5Cu0645%5Cu0627%20%5Cu0639%5Cu0646%5Cu062f%5Cu064a%20%5Cu0641%5Cu0643%5Cu0631%5Cu0629%20%5Cu0639%5Cu0646%20%5Cu0627%5Cu0644%5Cu0628%5Cu0646%5Cu0627%5Cu0621%5Cu060c%20%5Cu0641%5Cu0623%5Cu0646%5Cu062a%5Cu0648%20%5Cu0646%5Cu0628%5Cu0647%5Cu062a%5Cu0648%5Cu0646%5Cu064a%20%5Cu0639%5Cu0646%20%5Cu0623%5Cu0634%5Cu064a%5Cu0627%5Cu0621%20%5Cu0643%5Cu0627%5Cu0646%5Cu062a%20%5Cu0642%5Cu062f%5Cu0627%5Cu0645%5Cu064a%20%5Cu0644%5Cu0643%5Cu0646%20%5Cu0645%5Cu0627%20%5Cu0643%5Cu0646%5Cu062a%20%5Cu0623%5Cu0639%5Cu0631%5Cu0641%5Cu0647%5Cu0627%20%5Cu0648%5Cu062d%5Cu0641%5Cu0638%5Cu062a%5Cu0648%5Cu0627%20%5Cu0644%5Cu064a%20%5Cu0641%5Cu0644%5Cu0648%5Cu0633%5Cu064a.%5C%22%3Cbr%3E%22%2C%22name%22%3A%22%5Cu0631%5Cu0641%5Cu0639%5Cu0647%20%5Cu0627%5Cu0644%5Cu0645%5Cu0633%5Cu0645%5Cu0649%22%2C%22socialProfileUrl%22%3A%22%22%2C%22caption%22%3A%22%5Cu0627%5Cu0644%5Cu0631%5Cu064a%5Cu0627%5Cu0636%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Ffemale.png%22%2C%22websiteUrl%22%3A%22%22%2C%22logo%22%3Anull%2C%22rating%22%3A5%2C%22contentDivider%22%3Anull%7D%2C%7B%22text%22%3A%22%5C%22%5Cu0627%5Cu0644%5Cu0644%5Cu0647%20%5Cu064a%5Cu0639%5Cu0637%5Cu064a%5Cu0643%5Cu0645%20%5Cu0623%5Cu0644%5Cu0641%20%5Cu0639%5Cu0627%5Cu0641%5Cu064a%5Cu0629%20%5Cu0634%5Cu063a%5Cu0644%20%5Cu062c%5Cu0645%5Cu064a%5Cu0644%20%5Cu0648%5Cu0645%5Cu0631%5Cu062a%5Cu0628%5Cu060c%20%5Cu062f%5Cu0642%5Cu0629%20%5Cu0641%5Cu064a%20%5Cu0627%5Cu0644%5Cu0645%5Cu0644%5Cu0627%5Cu062d%5Cu0638%5Cu0627%5Cu062a.%5C%22%3Cbr%3E%22%2C%22name%22%3A%22%5Cu0639%5Cu0628%5Cu062f%5Cu0627%5Cu0644%5Cu0639%5Cu0632%5Cu064a%5Cu0632%20%5Cu0628%5Cu0646%20%5Cu062f%5Cu0631%5Cu064a%5Cu0647%5Cu0645%22%2C%22caption%22%3A%22%5Cu0627%5Cu0644%5Cu062f%5Cu0645%5Cu0627%5Cu0645%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Fmale.png%22%2C%22logo%22%3Anull%2C%22rating%22%3A4%2C%22contentDivider%22%3Anull%2C%22socialProfileUrl%22%3A%22%22%2C%22websiteUrl%22%3A%22%22%7D%2C%7B%22text%22%3A%22%5C%22%5Cu0646%5Cu0645%5Cu0648%5Cu0630%5Cu062c%20%5Cu062f%5Cu0642%5Cu064a%5Cu0642%20%5Cu0648%5Cu0645%5Cu0646%5Cu0638%5Cu0645%5Cu060c%20%5Cu062a%5Cu0639%5Cu0631%5Cu0641%5Cu062a%20%5Cu0639%5Cu0644%5Cu064a%5Cu0643%5Cu0645%20%5Cu0641%5Cu064a%20%5Cu0645%5Cu0639%5Cu0631%5Cu0636%20%5Cu0633%5Cu0643%5Cu0646%5Cu064a%5Cu060c%20%5Cu062a%5Cu0639%5Cu0627%5Cu0645%5Cu0644%5Cu0643%5Cu0645%20%5Cu0631%5Cu0627%5Cu0642%5Cu064a%20%5Cu0648%5Cu0645%5Cu0647%5Cu0646%5Cu064a%20%5Cu0627%5Cu062a%5Cu0645%5Cu0646%5Cu0649%20%5Cu062a%5Cu0639%5Cu0645%5Cu0644%5Cu0648%5Cu0627%20%5Cu062f%5Cu0639%5Cu0627%5Cu064a%5Cu0629%20%5Cu0628%5Cu0648%5Cu0633%5Cu0627%5Cu0626%5Cu0644%20%5Cu0627%5Cu0644%5Cu062a%5Cu0648%5Cu0627%5Cu0635%5Cu0644%20%5Cu0644%5Cu0644%5Cu062a%5Cu0639%5Cu0631%5Cu0641%20%5Cu0639%5Cu0644%5Cu064a%5Cu0643%5Cu0645.%5C%22%3Cbr%3E%22%2C%22name%22%3A%22%5Cu0648%5Cu0641%5Cu0627%5Cu0621%20%5Cu0633%5Cu0639%5Cu0648%5Cu062f%22%2C%22socialProfileUrl%22%3A%22%22%2C%22caption%22%3A%22%5Cu0627%5Cu0644%5Cu0631%5Cu064a%5Cu0627%5Cu0636%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Ffemale.png%22%2C%22websiteUrl%22%3A%22%22%2C%22logo%22%3Anull%2C%22rating%22%3A5%2C%22contentDivider%22%3Anull%7D%2C%7B%22text%22%3A%22%5C%22%5Cu0627%5Cu062e%5Cu062a%5Cu0631%5Cu062a%20%5Cu0623%5Cu062d%5Cu062f%20%5Cu0627%5Cu0644%5Cu0628%5Cu064a%5Cu0648%5Cu062a%20%5Cu0644%5Cu0644%5Cu0634%5Cu0631%5Cu0627%5Cu0621%20%5Cu0648%5Cu0631%5Cu063a%5Cu0628%5Cu062a%20%5Cu0623%5Cu0646%20%5Cu062a%5Cu0639%5Cu0637%5Cu064a%5Cu0646%5Cu064a%20%5Cu0639%5Cu0627%5Cu064a%5Cu0646%20%5Cu0623%5Cu0647%5Cu0645%20%5Cu0627%5Cu0644%5Cu0645%5Cu0644%5Cu0627%5Cu062d%5Cu0638%5Cu0627%5Cu062a%20%5Cu062d%5Cu062a%5Cu0649%20%5Cu0623%5Cu0639%5Cu0631%5Cu0641%5Cu0647%5Cu0627%20%5Cu0628%5Cu0633%5Cu0647%5Cu0648%5Cu0644%5Cu0629%20%5Cu0639%5Cu0644%5Cu0649%20%5Cu064a%5Cu062f%20%5Cu0645%5Cu062e%5Cu062a%5Cu0635%5Cu064a%5Cu0646%5Cu060c%20%5Cu0648%5Cu0642%5Cu062f%20%5Cu0623%5Cu0637%5Cu0644%5Cu0639%5Cu062a%5Cu0646%5Cu064a%20%5Cu0639%5Cu0644%5Cu0649%20%5Cu0645%5Cu0645%5Cu064a%5Cu0632%5Cu0627%5Cu062a%20%5Cu0648%5Cu0639%5Cu064a%5Cu0648%5Cu0628%20%5Cu0627%5Cu0644%5Cu0645%5Cu0646%5Cu0632%5Cu0644%20%5Cu0627%5Cu0644%5Cu062c%5Cu062f%5Cu064a%5Cu062f%20%5Cu0648%5Cu062c%5Cu0639%5Cu0644%5Cu062a%5Cu0646%5Cu064a%20%5Cu0623%5Cu062a%5Cu062e%5Cu0630%20%5Cu0627%5Cu0644%5Cu0642%5Cu0631%5Cu0627%5Cu0631%20%5Cu0628%5Cu0633%5Cu0647%5Cu0648%5Cu0644%5Cu0629%20%5Cu0648%5Cu0648%5Cu0636%5Cu0648%5Cu062d%20%5Cu0628%5Cu0627%5Cu0644%5Cu0634%5Cu0631%5Cu0627%5Cu0621%20%5Cu0645%5Cu0646%20%5Cu0639%5Cu062f%5Cu0645%5Cu0647.%5C%22%3Cbr%3E%22%2C%22contentDivider%22%3Anull%2C%22name%22%3A%22%5Cu0639%5Cu0628%5Cu064a%5Cu062f%20%5Cu0627%5Cu0644%5Cu0645%5Cu0646%5Cu062f%5Cu062d%22%2C%22socialProfileUrl%22%3A%22%22%2C%22caption%22%3A%22%5Cu0627%5Cu0644%5Cu0631%5Cu064a%5Cu0627%5Cu0636%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Fmale.png%22%2C%22websiteUrl%22%3A%22%22%2C%22logo%22%3A%7B%22name%22%3A%22%22%2C%22url%22%3A%22%22%7D%2C%22rating%22%3A5%7D%2C%7B%22text%22%3A%22%5C%22%5Cu062e%5Cu062f%5Cu0645%5Cu0629%20%5Cu0631%5Cu0627%5Cu0626%5Cu0639%5Cu0629%21%20%5Cu0643%5Cu0646%5Cu062a%20%5Cu0623%5Cu0631%5Cu064a%5Cu062f%20%5Cu0627%5Cu0644%5Cu062a%5Cu0623%5Cu0643%5Cu062f%20%5Cu0645%5Cu0646%20%5Cu0633%5Cu0644%5Cu0627%5Cu0645%5Cu0629%20%5Cu0627%5Cu0644%5Cu0645%5Cu0628%5Cu0646%5Cu0649%20%5Cu0627%5Cu0644%5Cu0630%5Cu064a%20%5Cu0633%5Cu0623%5Cu0642%5Cu062f%5Cu0645%20%5Cu0639%5Cu0644%5Cu0649%20%5Cu0634%5Cu0631%5Cu0627%5Cu0626%5Cu0647%5Cu060c%20%5Cu0648%5Cu0642%5Cu062f%20%5Cu0623%5Cu062c%5Cu0627%5Cu0628%5Cu062a%5Cu0646%5Cu064a%20%5Cu0639%5Cu0627%5Cu064a%5Cu0646%20%5Cu0639%5Cu0646%20%5Cu062c%5Cu0645%5Cu064a%5Cu0639%20%5Cu0627%5Cu0644%5Cu062a%5Cu0633%5Cu0627%5Cu0624%5Cu0644%5Cu0627%5Cu062a%20%5Cu0627%5Cu0644%5Cu062a%5Cu064a%20%5Cu0648%5Cu0627%5Cu062c%5Cu0647%5Cu062a%5Cu0646%5Cu064a.%5C%22%22%2C%22contentDivider%22%3Anull%2C%22name%22%3A%22%5Cu0639%5Cu0627%5Cu0626%5Cu0634%5Cu0629%20%5Cu0639%5Cu0633%5Cu064a%5Cu0631%5Cu064a%22%2C%22socialProfileUrl%22%3A%22%22%2C%22caption%22%3A%22%5Cu062a%5Cu0628%5Cu0648%5Cu0643%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Ffemale.png%22%2C%22websiteUrl%22%3A%22%22%2C%22logo%22%3A%7B%22name%22%3A%22%22%2C%22url%22%3A%22%22%7D%2C%22rating%22%3A5%7D%2C%7B%22text%22%3A%22%5C%22%5Cu0643%5Cu0646%5Cu062a%20%5Cu0623%5Cu0631%5Cu063a%5Cu0628%20%5Cu0628%5Cu0625%5Cu062c%5Cu0631%5Cu0627%5Cu0621%20%5Cu0641%5Cu062d%5Cu0635%20%5Cu0639%5Cu0627%5Cu0645%20%5Cu0644%5Cu0644%5Cu0641%5Cu064a%5Cu0644%5Cu0627.%20%5Cu0643%5Cu062b%5Cu064a%5Cu0631%20%5Cu0645%5Cu0634%5Cu0627%5Cu0643%5Cu0644%20%5Cu062d%5Cu0635%5Cu0644%5Cu062a%5Cu0647%5Cu0627%20%5Cu0628%5Cu0627%5Cu0644%5Cu0641%5Cu064a%5Cu0644%5Cu0627%20%5Cu0648%5Cu0643%5Cu0627%5Cu0646%5Cu062a%20%5Cu0633%5Cu0628%5Cu0628%20%5Cu0627%5Cu062a%5Cu062e%5Cu0627%5Cu0630%5Cu064a%20%5Cu0642%5Cu0631%5Cu0627%5Cu0631%20%5Cu0628%5Cu062a%5Cu0631%5Cu0643%5Cu0647%5Cu0627.%5C%22%22%2C%22contentDivider%22%3Anull%2C%22name%22%3A%22%5Cu0641%5Cu0647%5Cu062f%20%5Cu0639%5Cu0644%5Cu064a%20%5Cu0645%5Cu0628%5Cu0627%5Cu0631%5Cu0643%5Cu064a%22%2C%22socialProfileUrl%22%3A%22%22%2C%22caption%22%3A%22%5Cu062c%5Cu062f%5Cu0629%22%2C%22picture%22%3A%22../assets%5C%2Fimg%5C%2Fmale.png%22%2C%22websiteUrl%22%3A%22%22%2C%22logo%22%3A%7B%22name%22%3A%22%22%2C%22url%22%3A%22%22%7D%2C%22rating%22%3A5%7D%5D%2C%22textAlign%22%3A%22center%22%2C%22textView%22%3A%22full%22%2C%22testimonialTextColor%22%3A%22rgb%2817%2C%2025%2C%2052%29%22%2C%22backgroundColor%22%3A%22%22%2C%22authorNameColor%22%3A%22rgb%2817%2C%2025%2C%2052%29%22%2C%22captionColor%22%3A%22rgb%2817%2C%2025%2C%2052%29%22%2C%22starsColor%22%3A%22rgb%28255%2C%20207%2C%2089%29%22%2C%22widgetId%22%3A%221%22%7D"
              data-elfsight-testimonials-slider-version="1.6.1"
              data-elfsight-widget-id="elfsight-testimonials-slider-1"></div>
          </div>
        </div>
      </div>
    </div> -->

    <div id="blog" class="mhc_section  mhc_section_6 mh_section_regular" data-bg-color="#f3f3f3">
      <div class=" mhc_row mhc_row_7">
        <div class="mhc_column mhc_column_4_4 mhc_column_15">
          <div class="mhc_text mhc_module mhc_pct mhc_bg_layout_light mhc_text_align_center  mhc_text_11">
            <h1 :style='{
              "font-weight": "bold",
              "font-size": "24px",
            }'>{{ $t('blog') }}</h1>
          </div>
          <div class="mhc_blog_grid_wrapper  mhc_bg_layout_light">
            <div class="mhc_blog_grid clearfix  mhc_blog_0 mhc_bg_layout_light">
              <article id="post-8765" v-for="(item, index) in blog" :key="index" @click="moveToBlogItem(item)"
                class="mhc_post post-meta-below post-8765 post type-post status-publish format-standard has-post-thumbnail hentry category-11 tag-inspection tag-property tag-8 tag-6 tag-9">
                <div class="mhc_image_container">
                  <a class="featured_image_container">
                    <img :src="resolveImage(item.image)" :alt='resolveByLocal(item, "title")' width='400' height='250' />
                  </a>
                </div>
                <div class="mhc_post_content">
                  <div style=" text-overflow: ellipsis;" v-html="resolveByLocal(item, 'title')"></div>
                  <hr />
                  <button style="cursor: pointer; max-width: 200px" class="mo-btn">{{ $t('readmore') }}</button>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="contact" v-if="this.content.length > 0"
      class="mhc_section  mhc_section_8 mh_section_regular home-contact-part " data-bg-color="#6B1D45" :style='{
        "background-image": item?.img && `url(${resolveImage(item?.img)})`,
        "background-color": item?.backgroundColor ? item?.backgroundColor : "#6B1D45 !important",

      }'>
      <div class=" mhc_row mhc_row_9">
        <div class="mhc_column mhc_column_4_4 mhc_column_18">
          <div class="mhc_text mhc_module mhc_pct mhc_bg_layout_light mhc_text_align_center has-white-color">
            <h1 :style='{
              "color": item?.titleColor ? item?.titleColor : "#ffffff",
              "font-weight": "bold",
              "font-size": "24px",
            }'>{{ item?.title ? resolveByLocal(getSlideVideo, 'title') : $t('tslam') }}
            </h1>
          </div>
          <div class="mhc_button_wrapper  mhc_button_0 mhc_module mhc_text_align_center has-white-color  mhc_button_full">
            <router-link class="mhc_promo_button mhc_single_button mhc_solidify header-font-family" :style='{
              "color": item?.buttonColor ? item?.buttonColor : "#ffffff",
              "background-color": item?.buttonBackgroundColor ? item?.buttonBackgroundColor : "#3fb48d",
              "border-color": item?.buttonBorderColor ? item?.buttonBorderColor : "#3fb48d",
            }' :to="{ name: 'services' }">{{ $t('request_service') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/service/apis';
import { mapState } from "vuex";
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
export default {
  data() {
    return {
      blog: [],
      center: { lat: 25.2835518, lng: 51.5277331 },

    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
    },
  async created() {
    this.$store.dispatch('getContent')
    this.$store.dispatch('getSetting')

    await this.axios.get(apis.blog).then((res) => {
      this.blog = res.data.data;
    }).catch(() => {
      return false;
    })
  },
  methods: {
    moveToBlogItem(item) {
      this.$router.push({
        name: 'blogItem',
        params: { id: item.id }
      })
    },
    getMainFeature(index) {
      return this.content.find(item => item.name == 'mainFeature' + index) || {};
    },
    getMainFeatureImage(index) {
      return this.content.find(item => item.name == 'main_features_image' + index);
    },
  },
  computed: {
    ...mapState(['content', 'setting']),
    getSlide() {
      return this.content.find(item => item.name == 'bannar1');
    },
    getSlideVideo() {
      return this.content.find(item => item.name == "videoBanner");
    },
    getContentWithoutVideo() {
      return this.content.filter(item => item?.name === 'slider');
    },
    getMainFeatures() {
      return this.content.filter(item => item?.name.includes("mainFeature"));
    },
    getSlide3() {
      return this.content.find(item => item.name == 'bannar3');
    },
    getReviewsHome() {
      return this.content.filter(item => item.name === "homeReview");
    }
  },
}
</script>

<style scoped>
.mhc_slide_image {
  top: 28% !important;
}

.flex-column {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.carousel__slide {
  padding: 10px 0px !important;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.home-contact-part {
  background-repeat: repeat !important;
  background-size: auto !important;
}
</style>
